export default "__VITE_ASSET__DGRuWvsd__"